import { HeroEmailSignup } from "./HeroEmailSignup";

export function HeroContent() {
  return (
    <div className="relative w-full h-full min-h-[calc(var(--vh,1vh)*100)] grid place-items-center">
      <div className="w-full max-w-[540px] md:w-auto md:max-w-none text-center px-6 relative">
        <div
          className="absolute inset-0 -m-12 rounded-[40px] bg-radial-gradient from-black/80 to-transparent blur-[40px] opacity-100 z-0"
          style={{
            background:
              "radial-gradient(closest-side, rgba(36,32,33,0.8) 0%, rgba(36,32,33,0) 100%)",
          }}
        />
        {/* Layer a squircle blur to shape it */}
        <div className="absolute inset-0 -m-8 bg-black/40 rounded-[3rem] blur-[40px] -z-10" />

        <div className="relative z-60 mix-blend-difference text-white">
          {/* Announcement Banner */}
          <div className="mb-8 flex justify-center">
            <a
              href="/perspectives/announcing-seed-fundraise"
              className="group inline-flex items-center gap-2 rounded-full border border-white/20 bg-black/70 px-4 py-1.5 text-sm font-medium text-white transition-colors hover:bg-black/90"
            >
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-brand-green opacity-75"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-green"></span>
              </span>
              CoPlane announces $14M seed fundraise
              <svg
                className="h-4 w-4 transition-transform group-hover:translate-x-0.5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </a>
          </div>

          <h1 className="m-0 font-semibold text-[clamp(40px,5.5vw,72px)] leading-[1.05]">
            <span className="block w-full whitespace-normal sm:whitespace-nowrap">
              The intelligent operations layer
            </span>
            <span className="block w-full whitespace-normal sm:whitespace-nowrap">
              for the enterprise
            </span>
          </h1>
          <div className="mt-8">
            <HeroEmailSignup />
          </div>
          <p className="mt-8 mx-auto max-w-[540px] md:max-w-[700px] text-white/90 text-xl font-medium leading-relaxed">
            Turn your policies, data, and human expertise into
            <br className="hidden md:block" />
            agentic workflows—with full control, audit, and reliability.
          </p>

          {/* <div className="mt-16 flex flex-wrap items-center justify-center gap-x-12 gap-y-8 opacity-90">
            <img
              src="/assets/customers/2024_TKG-CompanyLogos-RW-500x300-1.webp"
              alt="Rand Whitney"
              className="h-15 w-auto object-contain"
            />
            <img
              src="/assets/customers/parts_authority.svg"
              alt="Parts Authority"
              className="h-6 w-auto object-contain"
            />
            <img
              src="/assets/customers/OI-Logo-v2-KO-300x155.webp"
              alt="O-I"
              className="h-8 w-auto object-contain"
            />
            <img 
                src="/assets/customers/gp-stacked.png" 
                alt="Global Partners" 
                className="h-10 w-auto object-contain"
                />
            <img
              src="/assets/customers/red_ventures.png"
              alt="Red Ventures"
              className="h-9 w-auto object-contain"
            />
          </div> */}
        </div>
      </div>
    </div>
  );
}

